module.exports = __webpack_public_path__ + "img/award-on.44cdf8d6.png";